<template>
  <MediumProductCard
    :title="productCardInfo.name"
    :image="productCardInfo.image"
    :discounted-price="productCardInfo.discountedPrice"
    :is-discounted="productCardInfo.isDiscounted"
    :last30-days-price="productCardInfo.last30DaysPrice"
    :link="productCardInfo.link"
    :sku="productCardInfo.sku"
    :currency="productCardInfo.currency"
    :product-box-type-tag="EVENT_SOURCE.PDP_COMPLEMENTARY_PRODUCTS"
    :rating="productCardInfo.rating"
    :reviews-count="productCardInfo.reviewsCount"
    :full-product-price="productCardInfo.fullProductPrice"
    :categories="productCardInfo.categories"
    :energy-rating="extractedAttributes.energyRating"
    :brand="extractedAttributes.brand"
    :tags="extractedAttributes.tags"
  />
</template>

<script lang="ts">

import { productGetters } from '~/utils/ct';

import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';
import {
  getProductAttributesExtended,
} from '~~/helpers/product/getProductAttributesExtended';
import { EVENT_SOURCE } from '~~/constants/googleTagManager';
import { PRODUCT_ATTRIBUTES } from '~~/constants/products';

export default defineComponent({
  name: 'PdpComplementaryProductCard',

  props: {
    product: {
      type: Object as PropType<ProductVariantExtended>,
      required: true,
    },
  },
  setup(props) {

    const { product } = toRefs(props);

    const { getPriceInformation } = useProductPrice();

    const { languageAndCountry } = useLocalization();

    const extractedAttributes = computed(() =>
      getProductAttributesExtended(product.value,
        {
          attributeNames: [PRODUCT_ATTRIBUTES.BRAND,
            PRODUCT_ATTRIBUTES.TAGS,
            PRODUCT_ATTRIBUTES.ENERGY_RATING,
          ],
          languageAndCountry: languageAndCountry.value,
        }),
    );

    const productCardInfo = computed(() => {

      const { fullProductPrice, discountedPrice, isDiscounted, last30DaysPrice } =
        getPriceInformation(product);

      return {
        sku: product.value?.sku,
        currency: product.value?.price?.value?.currencyCode || '',
        name: product.value?._name,
        image: product.value?.images?.[0]?.url,
        fullProductPrice: fullProductPrice.value,
        discountedPrice: discountedPrice.value,
        isDiscounted: isDiscounted.value,
        last30DaysPrice: last30DaysPrice.value,
        link: `/${product.value?._slug}`,
        rating: productGetters.getAverageRating(product.value),
        reviewsCount: productGetters.getTotalReviews(product.value),
        categories: product.value?._categories?.reduce((acc, category) => {

          acc[category.slug] = category.name;

          return acc;
        
        }) || '',
      };
    
    });

    return {
      productCardInfo,
      EVENT_SOURCE,
      extractedAttributes,
    };
  
  },
});

</script>
